import React from 'react';
import { LegalLayout } from './LegalLayout';
import { useLanguage } from '@/app/contexts/LanguageContext';

interface ImpressumProps {
  onBack: () => void;
}

export function Impressum({ onBack }: ImpressumProps) {
  const { language } = useLanguage();

  const content = {
    de: {
      title: 'Impressum',
      responsible: 'Verantwortlich für den Inhalt',
      contact: 'Kontakt',
      companyDetails: 'Unternehmensdaten',
      ceo: 'Geschäftsführer',
      court: 'Firmenbuchgericht',
      odr: 'Plattform der EU-Kommission zur Online-Streitbeilegung:',
      dispute: 'Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder verpflichtet noch bereit.'
    },
    en: {
      title: 'Imprint',
      responsible: 'Responsible for Content',
      contact: 'Contact',
      companyDetails: 'Company Details',
      ceo: 'CEO / Managing Director',
      court: 'Register Court',
      odr: 'EU Commission platform for online dispute resolution:',
      dispute: 'We are neither obligated nor willing to participate in a dispute settlement procedure before a consumer arbitration board.'
    }
  };

  const t = content[language];

  return (
    <LegalLayout title={t.title} onBack={onBack}>
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-bold text-slate-900 mb-2">{t.responsible}</h2>
          <p className="font-bold">Build Informed GmbH</p>
          <p>Egger-Lienz-Straße 130</p>
          <p>6020 Innsbruck</p>
          <p>Austria</p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-slate-900 mb-2">{t.contact}</h2>
          <p>E-Mail: <a href="mailto:info@buildinformed.com" className="text-purple-600 hover:underline">info@buildinformed.com</a></p>
          <p>Tel: +43 677 61 25 85 75</p>
        </div>

        <div>
          <h2 className="text-xl font-bold text-slate-900 mb-2">{t.companyDetails}</h2>
          <p>{t.ceo}: Jakob Hirn</p>
          <p>FN-Nr: FN 432 666z</p>
          <p>{t.court}: Landesgericht Innsbruck</p>
          <p>UID-Nr (Austria): ATU69579039</p>
          <p>UID-Nr (Switzerland): CHE-218.935.434</p>
        </div>
        
        <div className="mt-8 pt-8 border-t border-slate-200">
          <p className="text-sm text-slate-500">
            {t.odr} <a href="https://ec.europa.eu/odr" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline">https://ec.europa.eu/odr</a>
          </p>
          <p className="text-sm text-slate-500 mt-2">
            {t.dispute}
          </p>
        </div>
      </div>
    </LegalLayout>
  );
}
